import Modal from 'src/components/Modal'
import * as S from './ModalValidationBadge.styles'
import { useForm } from 'react-hook-form'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { actions } from 'src/features/tax-coupon/TaxCouponState'
import { handleOnKeyDown } from 'src/utils/Form'

interface ModalProps {
  showModal: boolean
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
}

interface FormData {
  badgeSupervisor: string
}

export default ({ showModal, setShowModal }: ModalProps) => {
  const [inputValue, setInputValue] = useState('')
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const {
    register, setError, reset, getValues, formState: { errors },
  } = useForm<FormData>()

  const dispatch = useDispatch()

  const handleInputChange = (event: { target: { value: string } }) => {
    const { value } = event.target
    setInputValue(value)
  }

  const onSubmit = () => {
    const badgeSupervisor = getValues('badgeSupervisor')

    if (!inputValue) {
      setError('badgeSupervisor', { message: 'Campo obrigatório' })
      return
    }

    setButtonDisabled(true)

    dispatch(actions.getReceivementUnitChange({
      badgeSupervisor,
      setError: (message: string) => setError('badgeSupervisor', { message }),
      setShowModal,
    }))

    setTimeout(() => {
      setButtonDisabled(false)
    }, 800)

    setInputValue('')
  }

  const onClickCancel = () => {
    setInputValue('')
    reset()
    setShowModal(false)
  }

  const returnModalBody = () => (
    <S.ContainerForm>
      <S.CustomTextField
        inputProps={{
          ...register('badgeSupervisor', { required: 'Campo obrigatório' }),
          'data-testid': 'badge-input',
        }}
        value={inputValue}
        id='badgeInput'
        name='badge'
        error={!!errors.badgeSupervisor}
        label='crachá'
        helperText={errors.badgeSupervisor?.message}
        type='password'
        autoComplete='off'
        onChange={handleInputChange}
        fullWidth
        onKeyDown={(e) => handleOnKeyDown(e, '', onSubmit)}
      />
      <S.CustomButton
        title='Validar crachá'
        type='submit'
        bgColor='confirm'
        hoverColor='confirmHover'
        letterColor='white'
        onClick={() => onSubmit()}
        data-testid='confirm-button-test'
        disabled={buttonDisabled}
      />
    </S.ContainerForm>
  )

  return (
    <Modal
      title='Validar crachá do supervisor'
      show={showModal}
      centered
      closeButtonAction={onClickCancel}
      testId='badge-validation-modal'
      body={returnModalBody()}
    />
  )
}
